import { useStore } from 'effector-react/compat'
import { $featuresMap } from '@entities/goods-features/model'

export const useFeaturesMap = () => useStore($featuresMap)
